module.exports = __webpack_public_path__ + "static/marvel-c93fe2fc93752bbdf68ba59ce9262335.jpg";